<template>
  <div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="w-full flex justify-end gap-3 items-center">
                <label class="vs-input--label">Bật/Tắt thu thập</label>
                <vs-switch color="success" v-model="isActive" v-if="isUpdate" vs-icon="done" @input="activeCrawl">
                </vs-switch>
                <label class="vs-input--label ml-4">Sao chép cấu hình</label>
                <feather-icon icon="ClipboardIcon" svgClasses="h-6 w-6 text-warning cursor-pointer"
                              @click.stop="copyPayload()"/>
              </div>
            </div>
            <vs-divider><h5 class="text-primary">Cấu hình Domain</h5></vs-divider>

            <div class="vx-col md:w-1/2 w-full mt-2">
              <label class="vs-input--label required">{{ $t('newspaper.nameDomain') }}</label>
              <vs-input
                v-validate="'required|min:3'"
                data-vv-validate-on="blur"
                type="text"
                name="nameDomain"
                v-model="newspaper.nameDomain"
                autocomplete="off"
                class="w-full" :disabled="isUpdate"/>
              <span class="text-danger text-sm">{{
                  errors.first("nameDomain")
                }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-2">
              <label class="vs-input--label required">{{ $t('newspaper.linkDomain') }}</label>
              <vs-input
                v-validate="'required'"
                data-vv-validate-on="blur"
                name="linkDomain"
                v-model="newspaper.linkDomain"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                  errors.first("linkDomain")
                }}</span>
            </div>

            <vs-divider class="mt-8"><h5 class="text-primary">Cấu hình nội dung</h5></vs-divider>

            <div class="vx-col w-full mt-6 px-4">
              <div class="vx-row border-solid d-theme-border-grey-light rounded-lg">
                <VuePerfectScrollbar
                  class="scroll-area--config-category vx-col w-full mt-2"
                  :settings="settings"
                  :key="$vs.rtl">
                  <vs-collapse accordion type="margin">
                    <vs-collapse-item v-for="(category, index) in configCategory" :key="index" v-if="category.isUpdate">
                      <div slot="header" class="flex flex-wrap" @click="selectCollapse($event)">
                        <span class="text-primary">{{
                            category.cateLink ? category.cateLink : 'Nội dung ' + (index + 1)
                          }}</span>
                        <vx-tooltip class="position-icon ml-4 flex items-center" text="Tạo bản sao" position="top">
                          <feather-icon icon="CopyIcon" svgClasses="h-5 w-5 text-warning cursor-pointer"
                                        @click.stop="duplicateRecord(category)"/>
                        </vx-tooltip>
                        <vx-tooltip class="position-icon ml-4 flex items-center" text="Xóa" position="top">
                          <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger cursor-pointer"
                                        @click.stop="confirmDeleteRecord(index)"/>
                        </vx-tooltip>
                        <vx-tooltip class="position-icon ml-4 flex items-center" text="Lịch sử ghi chú" position="top"
                                    v-if="category.chatNotes">
                          <feather-icon icon="MessageSquareIcon" svgClasses="h-5 w-5 text-primary cursor-pointer"
                                        @click.stop="openPopupChatNote(category.chatNotes, index)"/>
                        </vx-tooltip>
                        <vx-tooltip class="position-icon ml-4 flex items-center" text="Thêm ghi chú" position="top"
                                    v-else>
                          <feather-icon icon="PlusSquareIcon" svgClasses="h-5 w-5 text-primary cursor-pointer"
                                        @click.stop="openPopupChatNote(category.chatNotes, index)"/>
                        </vx-tooltip>
                        <vx-tooltip class="position-icon ml-4 flex items-center" text="Kiểm tra Xpath Link"
                                    position="top">
                          <feather-icon icon="CheckCircleIcon" svgClasses="h-5 w-5 text-success cursor-pointer"
                                        @click.stop="checkXpathLink(category, index)"/>
                        </vx-tooltip>
                        <vx-tooltip class="position-icon ml-4 flex items-center" text="Kiểm tra nội dung" position="top"
                                    v-if="category.list_link_crawler && category.list_link_crawler.length">
                          <feather-icon icon="CheckSquareIcon" svgClasses="h-5 w-5 text-success cursor-pointer"
                                        @click.stop="checkContents(category, index)"/>
                        </vx-tooltip>
                      </div>
                      <div class="vx-card p-4" style="height: 300px">
                        <vs-tabs v-model="activeTab">
                          <vs-tab label="Category" value="1">
                            <div class="vx-row">
                              <div class="vx-col lg:w-1/3 sm:w-1/2 w-full mt-2">
                                <label class="vs-input--label required">{{ $t('newspaper.cateLink') }}</label>
                                <vs-input
                                  v-validate="'required'"
                                  data-vv-validate-on="blur"
                                  name="cateLink"
                                  v-model="category.cateLink"
                                  autocomplete="off"
                                  class="w-full"/>
                              </div>
                              <div class="vx-col lg:w-1/3 sm:w-1/2 w-full mt-2">
                                <label class="vs-input--label">{{ $t('newspaper.rss') }}</label>
                                <vs-input
                                  data-vv-validate-on="blur"
                                  name="rss"
                                  v-model="category.rss"
                                  autocomplete="off"
                                  class="w-full"/>
                                <!--                      <span class="text-danger text-sm">{{-->
                                <!--                          errors.first("rss")-->
                                <!--                        }}</span>-->
                              </div>
                            </div>
                          </vs-tab>
                          <vs-tab label="Xpath Links" value="2">
                            <div class="vx-row">
                              <VuePerfectScrollbar
                                class="scroll-area--config-category-linkX vx-col w-full"
                                :settings="settings"
                                :key="$vs.rtl">
                                <div class="vx-row" v-for="(link, ind) in category.listLinksXpath" :key="ind">
                                  <div class="vx-col lg:w-1/2 md:w-2/3 w-3/4">
                                    <vs-input
                                      v-validate="'required|min:3'"
                                      data-vv-validate-on="blur"
                                      name="linksXpath"
                                      v-model="link.link"
                                      :class="{ 'border-danger': link.error }"
                                      autocomplete="off"
                                      class="w-full mb-2 last:mb-0"/>
                                    <span v-if="link.error" class="text-danger text-sm">{{ link.error }}</span> <!-- Hiển thị lỗi -->
                                  </div>
                                  <div class="vx-col lg:w-1/2 md:w-1/3 w-1/4 flex flex-wrap items-center gap-2">
                                    <vx-tooltip class="position-icon flex items-center" text="Xóa" position="top"
                                                v-if="category.listLinksXpath.length > 1">
                                      <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger cursor-pointer"
                                                    @click.stop="confirmDeleteLink(index, ind)"/>
                                    </vx-tooltip>
                                    <vx-tooltip class="position-icon flex items-center" text="Thêm" position="top"
                                                v-if="ind === category.listLinksXpath.length - 1">
                                      <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 text-success cursor-pointer"
                                                    @click.stop="addLink(index)"/>
                                    </vx-tooltip>

                                    <vx-tooltip class="position-icon ml-4 flex items-center" text="Kiểm tra Xpath Link"
                                                position="top">
                                      <feather-icon icon="CheckCircleIcon" svgClasses="h-5 w-5 text-success cursor-pointer"
                                                    @click.stop="checkXpathLinkSingle(index, ind)"/>
                                    </vx-tooltip>
                                  </div>
                                </div>
                              </VuePerfectScrollbar>
                            </div>
                          </vs-tab>
                          <vs-tab label="Contents" value="3">
                            <div class="vx-row">
                              <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">
                                <label class="vs-input--label required">Khốí nội dung({{
                                    $t('newspaper.contentParentXpath')
                                  }})</label>
                                <vs-input
                                  v-validate="'required|min:3'"
                                  data-vv-validate-on="blur"
                                  type="text"
                                  name="contentParentXpath"
                                  v-model="category.contentParentXpath"
                                  autocomplete="off"
                                  class="w-full"/>
                                <!--                          <span class="text-danger text-sm">{{-->
                                <!--                              errors.first("contentParentXpath")-->
                                <!--                            }}</span>-->
                              </div>
                              <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">
                                <label class="vs-input--label required">Tiêu đề ({{
                                    $t('newspaper.titleXpath')
                                  }})</label>
                                <vs-input
                                  v-validate="'required|min:3'"
                                  data-vv-validate-on="blur"
                                  type="text"
                                  name="titleXpath"
                                  v-model="category.titleXpath"
                                  autocomplete="off"
                                  class="w-full"/>
                                <!--                          <span class="text-danger text-sm">{{-->
                                <!--                              errors.first("titleXpath")-->
                                <!--                            }}</span>-->
                              </div>
                              <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">
                                <label class="vs-input--label">Mô tả ngắn gọn
                                  ({{ $t('newspaper.descriptionXpath') }})</label>
                                <vs-input
                                  data-vv-validate-on="blur"
                                  type="text"
                                  name="descriptionXpath"
                                  v-model="category.descriptionXpath"
                                  autocomplete="off"
                                  class="w-full"/>
                                <!--                          <span class="text-danger text-sm">{{-->
                                <!--                              errors.first("descriptionXpath")-->
                                <!--                            }}</span>-->
                              </div>
                              <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">
                                <label class="vs-input--label">Thời gian ({{
                                    $t('newspaper.timeXpath')
                                  }})</label>
                                <vs-input
                                  data-vv-validate-on="blur"
                                  name="timeXpath"
                                  v-model="category.timeXpath"
                                  autocomplete="off"
                                  class="w-full"/>
                                <!--                          <span class="text-danger text-sm">{{-->
                                <!--                              errors.first("timeXpath")-->
                                <!--                            }}</span>-->
                              </div>
                              <!--                              <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">-->
                              <!--                                <label class="vs-input&#45;&#45;label">{{ $t('newspaper.timeRegex') }}</label>-->
                              <!--                                <vs-input-->
                              <!--                                  data-vv-validate-on="blur"-->
                              <!--                                  name="timeRegex"-->
                              <!--                                  v-model="category.timeRegex"-->
                              <!--                                  autocomplete="off"-->
                              <!--                                  class="w-full"/>-->
                              <!--                          <span class="text-danger text-sm">{{-->
                              <!--                              errors.first("timeRegex")-->
                              <!--                            }}</span>-->
                              <!--                              </div>-->
                              <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">
                                <vs-input
                                  data-vv-validate-on="blur"
                                  name="textXpath"
                                  :label="$t('newspaper.textXpath')"
                                  v-model="category.textXpath"
                                  autocomplete="off"
                                  class="w-full"/>
                                <!--              <span class="text-danger text-sm">{{-->
                                <!--                  errors.first("textXpath")-->
                                <!--                }}</span>-->
                              </div>
                              <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">
                                <label class="vs-input--label">Ảnh minh họa ({{
                                    $t('newspaper.imageXpath')
                                  }})</label>
                                <vs-input
                                  data-vv-validate-on="blur"
                                  name="imageXpath"
                                  v-model="category.imageXpath"
                                  autocomplete="off"
                                  class="w-full"/>
                                <!--                          <span class="text-danger text-sm">{{-->
                                <!--                              errors.first("imageXpath")-->
                                <!--                            }}</span>-->
                              </div>
                              <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">
                                <label class="vs-input--label">Tác giả ({{
                                    $t('newspaper.authorXpath')
                                  }})</label>
                                <vs-input
                                  data-vv-validate-on="blur"
                                  name="authorXpath"
                                  v-model="category.authorXpath"
                                  autocomplete="off"
                                  class="w-full"/>
                                <!--                          <span class="text-danger text-sm">{{-->
                                <!--                              errors.first("authorXpath")-->
                                <!--                            }}</span>-->
                              </div>
                            </div>
                          </vs-tab>
                        </vs-tabs>
                      </div>
                    </vs-collapse-item>
                  </vs-collapse>
                </VuePerfectScrollbar>
                <vs-divider></vs-divider>
                <div class="vx-col w-full">
                  <vs-button icon-pack="feather" icon="icon-plus" type="border" class="mb-2" @click="addConfig">Thêm
                  </vs-button>
                </div>
              </div>
            </div>

          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap gap-2 items-center justify-end">
                <vs-button class="mt-2" color="warning" @click="copyConfig" v-if="isUpdate">Sao chép
                </vs-button>
                <vs-button class="mt-2" @click="confirmCheckConfig($event, false)"
                           :disabled="!validateForm"
                           v-if="isUpdate">Kiểm tra
                  cấu hình
                </vs-button>
                <vs-button class="mt-2" @click="saveChanges" :disabled="!validateForm">{{
                    `${isUpdate ?
                      $t('adminUser.updateUser') : $t('adminUser.createUser')}`
                  }}
                </vs-button>
                <vs-button class="mt-2" type="border" color="warning" @click="$router.push('/admin/newspaper/manage')">
                  {{ $t('adminUser.back') }}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vs-popup title="Kết quả kiểm tra cấu hình" :active.sync="popupActiveResultCheckConfig" id="result-config">
      <vs-table max-items="5" pagination :data="dataResultCheck">
        <template slot="thead">
          <vs-th>
            STT
          </vs-th>
          <vs-th>
            Link Category
          </vs-th>
          <vs-th>
            Author Xpath
          </vs-th>
          <vs-th>
            Content Xpath
          </vs-th>
          <vs-th>
            Description Xpath
          </vs-th>
          <vs-th>
            Image Xpath
          </vs-th>
          <vs-th>
            Text Xpath
          </vs-th>
          <vs-th>
            Time Xpath
          </vs-th>
          <vs-th>
            Title Xpath
          </vs-th>
          <vs-th>
            Hành động
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ indextr + 1 }}
            </vs-td>

            <vs-td>
              {{ tr.linkCate }}
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="tr.authorXpath"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="tr.contentXpath"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="tr.descriptionXpath"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="tr.imageXpath"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="tr.textXpath"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="tr.timeXpath"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="tr.titleXpath"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <vx-tooltip class="position-icon" text="Xem bài báo" position="top">
                <feather-icon icon="FileTextIcon" svgClasses="h-5 w-5 text-primary cursor-pointer"
                              @click="showNewspaper(tr)"/>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-popup title="" :active.sync="popupActiveShowNewspaper" id="show-newspaper">
        <vs-collapse accordion type="margin">
          <vs-collapse-item v-for="(news, index) in dataNewspaper" :key="index">
            <div slot="header">
              <h4>{{ news.title_crawler_value }}</h4>
            </div>
            <h6>{{ news.author_crawler_value }}</h6>
            <span>{{ convertTimeCrawler(news.time_crawler_value) }}</span>
            <div class="mt-4"><h5>{{ news.description_crawler_value }}</h5></div>
            <br>
            <div v-for="(content, ind) in news.content_crawler_value" :key="ind"
                 v-if="news.content_crawler_value.length > 0" class="mt-4">
              <img v-if="content.type === 'img'" :src="content.content" alt="" style="width: 100%; height: auto">
              <div v-if="content.type === 'text'" v-html="content.content" class="full-content"></div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </vs-popup>
    </vs-popup>

    <vs-popup :title="titlePopupChatNote" :active.sync="activePopupChatNote">
      <div class="relative overflow-hidden">
        <div class="chat__bg no-scroll-content chat-content-area">
          <template>
            <VuePerfectScrollbar class="chat-content-scroll-area"
                                 :settings="settings" ref="chatLogPS" :key="$vs.rtl">
              <div class="chat__log" ref="chatLog">
                <div class="m-8" v-if="dataChatNote.length">
                  <div v-for="(msg, index) in dataChatNote" class="msg-grp-container" :key="index">
                    <div class="flex items-start"
                         :class="[{'flex-row-reverse' : msg.role === 2}]">
                      <div :class="[{'mt-4' : dataChatNote[index-1] && msg.role === dataChatNote[index-1].role}]">
                        <div class="flex items-start"
                             :class="[{'flex-row-reverse' : msg.role === 2}]">
                          <vs-avatar size="35px" color="primary" text="TTXVN" v-if="msg.role === 1"/>
                          <vs-avatar size="35px" color="#059862" text="System" v-if="msg.role === 2"/>

                          <div
                            class="msg break-words relative shadow-md rounded py-3 px-4 rounded-lg max-w-sme"
                            :class="{'bg-white': msg.role === 2, 'bg-slate-100': msg.role === 1}">
                            <span class="text-base">{{ msg.message }}</span>
                          </div>
                        </div>
                        <div>
                          <span class="text-xs ml-2">{{ msg.sendAt }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center" v-else>
                  <span class="text-lg">Không có dữ liệu ghi chú</span>
                </div>
              </div>
            </VuePerfectScrollbar>
            <vs-divider class="-mb-2"/>
            <div class="chat__input p-4 bg-white flex gap-2">
              <vs-textarea height="80px" class="flex-1" placeholder="Nhập ghi chú ..." v-model="typedMessage"/>
              <div class="">
                <div class="mb-2">
                  <vs-button class="" type="filled" @click="sendMsg(1)">TTXVN</vs-button>
                </div>
                <vs-button class="" type="border" @click="sendMsg(2)">System</vs-button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </vs-popup>

    <vs-popup class="" title="Kết quả kiểm tra cấu hình" :active.sync="activePopupCheckContent"
              id="result-check-content">
      <vs-table max-items="15" pagination :data="dataCheckContent">
        <template slot="thead">
          <vs-th>
            STT
          </vs-th>
          <vs-th>
            Author Xpath
          </vs-th>
          <vs-th>
            Content Parent Xpath
          </vs-th>
          <vs-th>
            Content Xpath
          </vs-th>
          <vs-th>
            Description Xpath
          </vs-th>
          <vs-th>
            Image Xpath
          </vs-th>
          <vs-th>
            Time Xpath
          </vs-th>
          <vs-th>
            Title Xpath
          </vs-th>
          <vs-th>
            Hành động
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ indextr + 1 }}
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="checkErr(tr.authorXpath)"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="tr.contentParentXpath"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="checkErr(tr.contentXpath)"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="checkErr(tr.descriptionXpath)"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="checkErr(tr.imageXpath)"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="checkErr(tr.timeXpath)"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-success" v-if="checkErr(tr.titleXpath)"/>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-danger" v-else/>
            </vs-td>

            <vs-td>
              <vx-tooltip class="position-icon" text="Xem bài báo" position="top" v-if="!tr.isError">
                <feather-icon icon="FileTextIcon" svgClasses="h-5 w-5 text-primary cursor-pointer"
                              @click="showContentNews(tr)"/>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-popup title="Thông tin bài báo" :active.sync="popupShowContentNews" id="content-news">
        <h4>{{ contentNews ? contentNews.titleXpathValue : null }}</h4>
        <h6 class="mt-4">{{ contentNews ? contentNews.authorXpathValue : null }}</h6>
        <span>{{ convertTimeCrawler(contentNews ? contentNews.timeXpathValue : null) }}</span>
        <div class="mt-4">
          <h5>{{ contentNews ? contentNews.descriptionXpathValue : null }}</h5>
        </div>
        <br>
        <div v-if="contentNews && contentNews.contentXpathValue && contentNews.contentXpathValue.length">
          <div v-for="(content, ind) in contentNews.contentXpathValue" :key="ind" class="mt-4">
            <img v-if="content.type === 'img'" :src="content.content" alt="" style="width: 100%; height: auto">
            <div v-if="content.type === 'text'" v-html="content.content" class="full-content"></div>
          </div>
        </div>
      </vs-popup>
    </vs-popup>
  </div>

</template>
<script>

import vSelect from 'vue-select'
import Datepicker from '@/components/datepicker/Datepicker.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from "moment";
import authConfig from "../../../../auth_config.json";

export default {
  data() {
    return {
      isUpdate: false,
      id: null,
      newspaper: {
        linkDomain: null,
        nameDomain: null,
        // numberOrder: 0,
      },
      numberOptions: [
        {value: 0, label: '0'},
        {value: 1, label: '1'},
        {value: 2, label: '2'},
        {value: 3, label: '3'},
        {value: 4, label: '4'},
        {value: 5, label: '5'},
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.70,
      },
      configCategory: [{
        rss: null,
        cateLink: null,
        authorXpath: null,
        contentParentXpath: null,
        descriptionXpath: null,
        imageXpath: null,
        listLinksXpath: [{link: null}],
        textXpath: null,
        timeRegex: `%d/%m/%Y %H:%M`,
        timeXpath: null,
        titleXpath: null,
        isUpdate: 2,
      }],
      dataResultCheck: [],
      popupActiveResultCheckConfig: false,
      popupActiveShowNewspaper: false,
      dataNewspaper: [],
      isActive: false,
      activePopupChatNote: false,
      dataChatNote: [],
      indexSelect: null,
      titlePopupChatNote: null,
      typedMessage: null,
      dataCheckContent: [],
      activePopupCheckContent: false,
      contentNews: null,
      popupShowContentNews: false,
      activeTab: 3,
    };
  },
  components: {
    vSelect,
    Datepicker,
    VuePerfectScrollbar
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },

    convertHtml() {
      return (value) => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(value, 'text/html');
        return doc.body;
      }
    }
  },
  created() {
    let nameDomain = this.$route.query.nameDomain;
    if (nameDomain) {
      this.findById(nameDomain)
    } else {
      let newpaper = JSON.parse(localStorage.getItem('newpaper'))
      let configCategory = JSON.parse(localStorage.getItem('configCategory')).map(({['id']: _, ...el}) => el)
      if (newpaper && configCategory) {
        this.newspaper = newpaper;
        this.configCategory = configCategory;
        localStorage.removeItem('newpaper')
        localStorage.removeItem('configCategory')
      }
    }
  },
  methods: {
    findById(nameDomain) {
      this.$vs.loading();
      this.$task.post('/newspaper/find-all-by-domain', {nameDomain: nameDomain}).then((res) => {
        this.$vs.loading.close();
        this.newspaper = {
          linkDomain: res.data[0].linkDomain,
          nameDomain: res.data[0].nameDomain,
        }

        this.configCategory = res.data.map(el => {
          return {
            id: el.id,
            rss: el.rss,
            cateLink: el.cateLink,
            authorXpath: el.authorXpath,
            contentParentXpath: el.contentParentXpath,
            descriptionXpath: el.descriptionXpath,
            imageXpath: el.imageXpath,
            listLinksXpath: el.linksXpath.map(x => {
              return {
                link: x
              }
            }),
            textXpath: el.textXpath,
            timeRegex: el.timeRegex,
            timeXpath: el.timeXpath,
            titleXpath: el.titleXpath,
            isUpdate: 1,
            chatNotes: el.chatNotes,
          }
        })
        this.isActive = !!res.data[0].active
        this.isUpdate = true;
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },

    async saveChanges(evt) {

      // await this.confirmCheckConfig(evt, true)

      evt.preventDefault();
      if (!this.validateForm) return;

      const result = await this.$validator.validateAll();
      if (!result) return this.$vs.notify({
        text: 'Hãy điền đầy đủ các trường thông tin bắt buộc!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      });
      // if (!this.newspaper.numberOrder) this.newspaper.numberOrder = 0;
      this.configCategory = this.configCategory.map(el => {
        el.rss = (el.rss && el.rss.trim().length > 0) ? el.rss : null;
        return el;
      })

      let listLinkCate = this.configCategory.map(el => el.cateLink.trim());
      let listRss = this.configCategory.map(el => el.rss && el.rss.trim()).filter(el => el);

      if (listLinkCate.length > 1) {
        let result = Array.from(new Set(listLinkCate));
        if (result.length < listLinkCate.length) {
          return this.$vs.notify({
            text: 'Không được nhập trùng trường dữ liệu Link category!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      }
      if (listRss.length > 1) {
        let result = Array.from(new Set(listRss));
        if (result.length < listRss.length) {
          return this.$vs.notify({
            text: 'Không được nhập trùng trường dữ liệu RSS!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      }

      let data = this.configCategory.map(el => {
        return {...el, ...this.newspaper}
      })
      data = data.map(el => {
        el.linksXpath = el.listLinksXpath.map(x => x.link);
        el.active = +this.isActive;
        return el;
      })

      let path = this.isUpdate ? ('/newspaper/update') : '/newspaper/create';
      this.$vs.loading();
      this.$task.post(path, data).then(() => {
        this.$vs.loading.close();
        this.$vs.notify({
          color: 'primary',
          text: this.$t('newspaper.successText'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
        this.findById(this.newspaper.nameDomain)
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },

    checkConfig(data, isCreate) {
      return new Promise((resolve, reject) => {
        this.$vs.loading();
        this.$task5002.post(`/start_task`, data).then((res) => {
          if (res.data.data && !!res.data.data.length) {
            let result = {
              authorXpath: res.data.data[0].author_crawler_value ? 1 : 0,
              contentXpath: res.data.data[0].content_crawler_value ? 1 : 0,
              descriptionXpath: res.data.data[0].description_crawler_value ? 1 : 0,
              imageXpath: res.data.data[0].image_crawler_value ? 1 : 0,
              textXpath: res.data.data[0].content_crawler_value ? 1 : 0,
              timeXpath: res.data.data[0].time_crawler_value ? 1 : 0,
              titleXpath: res.data.data[0].title_crawler_value ? 1 : 0,
              newspaper: isCreate ? res.data.data : res.data.data.filter(x => !x.error),
              linkCate: data.cateLink
            }
            this.dataResultCheck.push(result)
          }
          resolve(res);
          this.$vs.loading.close();
        }).catch((err) => {
          reject(err);
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      })
    },

    confirmCheckConfig(evt, isCreate) {
      return new Promise(async (resolve, reject) => {
        evt.preventDefault();
        if (!this.validateForm) return;

        const result = await this.$validator.validateAll();
        if (!result) return this.$vs.notify({
          text: 'Hãy điền đầy đủ các trường thông tin bắt buộc!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
        this.configCategory = this.configCategory.map(el => {
          el.rss = (el.rss && el.rss.trim().length > 0) ? el.rss : null;
          return el;
        })

        let listLinkCate = this.configCategory.map(el => el.cateLink.trim());
        let listRss = this.configCategory.map(el => el.rss && el.rss.trim()).filter(el => el);

        if (listLinkCate.length > 1) {
          let result = Array.from(new Set(listLinkCate));
          if (result.length < listLinkCate.length) {
            return this.$vs.notify({
              text: 'Không được nhập trùng trường dữ liệu Link category!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        }
        if (listRss.length > 1) {
          let result = Array.from(new Set(listRss));
          if (result.length < listRss.length) {
            return this.$vs.notify({
              text: 'Không được nhập trùng trường dữ liệu RSS!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        }
        this.dataResultCheck = []
        let data = this.configCategory.map(el => {
          return {...el, ...this.newspaper}
        });
        data = data.map(el => {
          el.linksXpath = el.listLinksXpath.map(x => x.link)
          return el;
        })
        for (const el of data) {
          await this.checkConfig(el, isCreate);
        }

        if (isCreate) {
          this.dataNewspaper = [];
          let data = this.dataResultCheck[0]
          if (data.newspaper.length > 0 && data.descriptionXpath && data.authorXpath && data.contentXpath && data.imageXpath && data.textXpath && data.timeXpath && data.titleXpath) {
            // this.dataNewspaper = data.newspaper
            // this.popupActiveShowNewspaper = true;
            resolve()
          } else {
            this.popupActiveResultCheckConfig = true;
            reject()
            return this.$vs.notify({
              text: data.newspaper[0].list_link_crawler ? data.newspaper[0].list_link_crawler : 'Cấu hình lỗi!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        } else {
          resolve()
          this.popupActiveResultCheckConfig = true;
        }
      })
    },

    addConfig() {
      this.configCategory.push({
        rss: null,
        cateLink: null,
        authorXpath: null,
        contentParentXpath: null,
        descriptionXpath: null,
        imageXpath: null,
        listLinksXpath: [{link: null}],
        textXpath: null,
        timeRegex: '%d/%m/%Y %H:%M',
        timeXpath: null,
        titleXpath: null,
        isUpdate: 2,
      })
    },

    deleteConfig(index) {
      // this.configCategory.splice(index, 1)
      this.configCategory[index].isUpdate = 0;
    },

    copyConfig() {
      localStorage.setItem('newpaper', JSON.stringify(this.newspaper))
      localStorage.setItem('configCategory', JSON.stringify(this.configCategory))
      this.$router.push(`/admin/newspaper/add`).catch(() => {
      });
      setTimeout(() => {
        location.reload()
      })
    },

    confirmDeleteRecord(index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('adminUser.deleteConfirmation'),
        text: `${this.$t('newspaper.deleteConfirmation')} `,
        accept: () => this.deleteConfig(index),
        acceptText: this.$t('adminUser.acceptText'),
        cancelText: this.$t('adminUser.cancelText')
      })
    },

    addLink(index) {
      this.configCategory[index].listLinksXpath.push({link: null});
      this.configCategory[index].isUpdate = this.configCategory[index].id ? 1 : 2
    },

    confirmDeleteLink(index, ind) {
      this.configCategory[index].listLinksXpath.splice(ind, 1);
      this.configCategory[index].isUpdate = this.configCategory[index].id ? 1 : 2
    },

    duplicateRecord(data) {
      this.configCategory.push({
        rss: null,
        cateLink: null,
        authorXpath: data.authorXpath,
        contentParentXpath: data.contentParentXpath,
        descriptionXpath: data.descriptionXpath,
        imageXpath: data.imageXpath,
        listLinksXpath: data.listLinksXpath,
        textXpath: data.textXpath,
        timeRegex: data.timeRegex,
        timeXpath: data.timeXpath,
        titleXpath: data.titleXpath,
        isUpdate: 2
      })
    },

    showNewspaper(data) {
      this.dataNewspaper = [];
      if (data.newspaper.length > 0 && data.descriptionXpath && data.authorXpath && data.contentXpath && data.imageXpath && data.textXpath && data.timeXpath && data.titleXpath) {
        this.dataNewspaper = data.newspaper
        this.popupActiveShowNewspaper = true;
      } else {
        return this.$vs.notify({
          text: 'Không lấy được danh sách bài báo!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
    },

    convertTimeCrawler(time) {
      let date = new Date(time);
      let day = String(date.getUTCDate()).padStart(2, '0');
      let month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Tháng bắt đầu từ 0
      let year = date.getUTCFullYear();
      let hours = String(date.getUTCHours()).padStart(2, '0');
      let minutes = String(date.getUTCMinutes()).padStart(2, '0');
      let seconds = String(date.getUTCSeconds()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },

    async activeCrawl() {
      if (this.isActive) {
        this.dataResultCheck = []
        let data = this.configCategory.map(el => {
          return {...el, ...this.newspaper}
        });
        data = data.map(el => {
          el.linksXpath = el.listLinksXpath.map(x => x.link)
          return el;
        })
        for (const el of data) {
          await this.checkConfig(el, false);
        }

        let check = this.dataResultCheck[0]
        if (check.newspaper.length > 0 && check.descriptionXpath && check.authorXpath && check.contentXpath && check.imageXpath && check.textXpath && check.timeXpath && check.titleXpath) {
          this.confirmActive()
        } else {
          this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: this.$t('adminUser.deleteConfirmation'),
            text: 'Xác nhận thu thập dữ liệu trong khi cấu hình sai!',
            accept: this.confirmActive,
            cancel: () => this.changeStaus(false),
            acceptText: 'Đồng ý',
            cancelText: this.$t('adminUser.cancelText')
          })
        }
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('adminUser.deleteConfirmation'),
          text: 'Xác nhận dừng thu thập dữ liệu!',
          accept: this.confirmActive,
          cancel: () => this.changeStaus(false),
          acceptText: 'Đồng ý',
          cancelText: this.$t('adminUser.cancelText')
        })
      }
    },

    confirmActive() {
      let nameDomain = this.$route.query.nameDomain,
        status = this.isActive ? 1 : 0;
      this.$vs.loading();
      this.$task.post(`/newspaper/change-status-active?domainName=${nameDomain}&status=${status}`, {}).then(() => {
        this.$vs.loading.close();
        this.$vs.notify({
          color: 'primary',
          text: this.$t('newspaper.successText'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
        this.findById(this.newspaper.nameDomain)
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },

    changeStaus(status) {
      this.isActive = status;
    },

    openPopupChatNote(data, index) {
      this.indexSelect = index;
      this.dataChatNote = data ? JSON.parse(data) : [];
      this.titlePopupChatNote = data ? 'Lịch sử ghi chú' : 'Thêm ghi chú';
      this.activePopupChatNote = true;
    },

    sendMsg(num) {
      this.typedMessage = this.typedMessage.trim();
      if (!this.typedMessage.length) {
        return this.$vs.notify({
          text: 'Ghi chú bắt buộc phải có nội dung!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
      let msg = {
        message: this.typedMessage,
        role: num,
        sendAt: moment(new Date()).format('HH:mm DD/MM/YYYY')
      }
      this.dataChatNote.push(msg);
      this.configCategory[this.indexSelect].chatNotes = JSON.stringify(this.dataChatNote);
      this.typedMessage = '';
      this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight;
    },

    copyPayload: function () {
      let data = this.configCategory.map(el => {
        return {...el, ...this.newspaper}
      })
      const textarea = document.createElement('textarea');
      textarea.textContent = JSON.stringify(data);
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      return this.$vs.notify({
        text: 'Sao chép cấu hình thành công!',
        iconPack: 'feather',
        icon: 'icon-check-circle',
        color: 'success'
      });
    },

    checkXpathLink(category, index) {
      let data = this.configCategory[index];
      data.linksXpath = category.listLinksXpath.map(el => el.link);
      data = {...data, ...this.newspaper};
      this.$vs.loading();
      this.$task5001.post(`/start_task_links`, data).then(res => {
        if (res.data && res.data.data) {
          this.configCategory[index].list_link_crawler = res.data.data.list_link_crawler;
        }
        this.$forceUpdate();
        this.$vs.loading.close();
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },


    checkXpathLinkSingle( index, ind) {
      let data = this.configCategory[index];
      let linkXpath = data.listLinksXpath[ind].link;
      console.log('Category:', data);
      console.log('Index:', index);
      console.log('ind:', ind);
      console.log('linkXpath:', linkXpath);

      data.linksXpath = linkXpath;
      data = {
        ...data,
        linksXpath: [linkXpath],
        ...this.newspaper,
      };
      this.$vs.loading();
      this.$task5001.post(`/start_task_links`, data).then(res => {
        if (res.data && res.data.data) {
          this.configCategory[index].list_link_crawler = res.data.data.list_link_crawler;
          if (res.data && res.data.data.validate_config_cron) {
            // Nếu validate_config_cron là true, không có lỗi
            this.$set(data.listLinksXpath[ind], 'error', false); // Xóa lỗi
          } else {
            // Nếu validate_config_cron là false, có lỗi
            this.$set(data.listLinksXpath[ind], 'error', res.data.data.data);
          }
        }
        this.$forceUpdate();
        this.$vs.loading.close();
      }).catch((err) => {

        this.$set(data.listLinksXpath[ind], 'error', true);

        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });




      });


    },

    checkContents(category, index) {
      let data = this.configCategory[index];
      data.linksXpath = category.listLinksXpath.map(el => el.link);
      data = {...data, ...this.newspaper};
      this.dataCheckContent = [];
      this.$vs.loading();
      this.$task5002.post(`/start_task`, data).then(res => {
        if (res.data && res.data.data.length) {
          this.dataCheckContent = res.data.data.map(tr => {
            if (!this.checkErr(tr.authorXpath) || !this.checkErr(tr.contentParentXpath) || !this.checkErr(tr.contentXpath) || !this.checkErr(tr.descriptionXpath) || !this.checkErr(tr.imageXpath) || !this.checkErr(tr.timeXpath) || !this.checkErr(tr.titleXpath)) {
              tr.isError = true;
            }
            return tr;
          });
          this.activePopupCheckContent = true;
        }
        this.$vs.loading.close()
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },

    checkErr(data) {
      return data && !data.includes('lỗi')
    },

    showContentNews(data) {
      this.contentNews = data;
      this.popupShowContentNews = true;
    },

    selectCollapse(evt) {
      this.activeTab = 3;
    }
  }
};
</script>

<style lang="scss" scoped>
.border-danger {
  border: 1px solid red !important; /* Viền đỏ */
  border-radius: 4px; /* Bo góc, nếu cần */
}

.vs-divider {
  margin: 10px 0;
}

.required:after {
  content: " *";
  color: red;
}

.scroll-area--config-category {
  max-height: calc(var(--vh, 1vh) * 100 - 550px);
  min-height: 300px;
}

.scroll-area--config-category-linkX {
  height: 200px;
}
</style>

<style lang="scss">
#result-config,
#result-check-content {
  .vs-popup {
    width: 80% !important;
  }
}

#show-newspaper,
#content-news {
  .vs-popup {
    width: 50% !important;
  }

  .full-content {
    img {
      width: 100%;
      height: auto;
    }
  }
}

.chat-content-area {
  position: relative;


  .chat-content-scroll-area {
    position: relative;
    margin: auto;
    width: 100%;
    height: calc(100% - 100px);

    .chat__input {
      position: absolute;
      bottom: 0;
      width: 100%;
    }

    .bg-slate-100 {
      background-color: rgb(241 245 249);
    }
  }
}
</style>
